"use client";

import { GoogleOAuthProvider as GoogleOAuthProviderLib } from "@react-oauth/google";
import { ReactNode } from "react";

import { publicEnv } from "@/env/public-env";

interface GoogleOAuthProviderProps {
  children: ReactNode;
}

export function GoogleOauthProvider({ children }: GoogleOAuthProviderProps) {
  const clientId = publicEnv.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

  if (!clientId) {
    console.warn("NEXT_PUBLIC_GOOGLE_CLIENT_ID is not configured");
    return <>{children}</>;
  }

  return (
    <GoogleOAuthProviderLib clientId={clientId}>
      {children}
    </GoogleOAuthProviderLib>
  );
}
